// src/config.ts — single source of truth for model IDs, endpoints, and audio contracts.
// Mirrors LLABARO.py / LLABARO.jsx; verified July 2026. See LLABARO-grounding.md §2.

export const LISTEN_MODEL = "gemini-3.5-live-translate-preview"; // dedicated live-translate (preview)
// Model actually used for live listen via the @google/genai SDK. A native-audio Live model
// driven with a strict "translate only" system instruction — robust and well-documented,
// unlike the dedicated translate model's undocumented setup config.
export const LIVE_MODEL = "gemini-2.5-flash-native-audio-latest";
// Talk-mode transcribe+translate. Stable alias to the current flash model: the pinned
// "gemini-2.5-flash" 404s on 2026-era keys that only carry 3.x text models.
export const TEXT_MODEL = "gemini-flash-latest";
// Native TTS via generateContent (responseModalities: ["AUDIO"] + speechConfig).
export const TTS_MODEL = "gemini-2.5-flash-preview-tts";

export const LIVE_INPUT_HZ = 16_000; // Live input: 16-bit PCM, 16 kHz, mono, little-endian
export const LIVE_OUTPUT_HZ = 24_000; // Live / TTS output: 16-bit PCM, 24 kHz, mono
export const SAMPLE_WIDTH = 2; // bytes per sample (16-bit)

export const GOOGLE_BASE = "https://generativelanguage.googleapis.com";

export const RECONNECT_BACKOFF_MS = [500, 1000, 2000, 4000]; // grounding §6
export const PLAYBACK_DRAIN_MS = 200; // silence gap after TTS before resuming listen
export const MIN_TALK_MS = 250; // shorter capture is treated as CANCEL (edge case E10)

// Google AI Studio API-key page — where BYOK users get a free Gemini key.
export const AI_STUDIO_URL = "https://aistudio.google.com/apikey";

// Prebuilt Gemini TTS voices offered in the settings picker (default "Kore").
export const TTS_VOICES = [
  "Kore",
  "Puck",
  "Charon",
  "Fenrir",
  "Aoede",
  "Leda",
  "Orus",
  "Zephyr",
  "Callirrhoe",
  "Autonoe",
];
